import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PageLayout } from '../components/layout/PageLayout';
import { CampaignCard } from '../components/campaign/CampaignCard';
import { Button } from '../components/ui/button';
import { api } from '../lib/api';
import { toast } from 'sonner';
import { Plus, Heart, FolderOpen } from 'lucide-react';

export default function MyCampaignsPage() {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCampaigns();
  }, []);

  const fetchCampaigns = async () => {
    try {
      const response = await api.get('/campaigns?my_campaigns=true');
      setCampaigns(response.data);
    } catch (error) {
      toast.error('Failed to load campaigns');
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageLayout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold text-foreground">My Campaigns</h1>
            <p className="text-muted-foreground mt-1">
              Manage your fundraising campaigns
            </p>
          </div>
          <Link to="/campaigns/new">
            <Button className="rounded-full gap-2" data-testid="new-campaign-btn">
              <Plus className="w-4 h-4" />
              New Campaign
            </Button>
          </Link>
        </div>

        {/* Campaigns */}
        {loading ? (
          <div className="flex items-center justify-center py-20">
            <div className="flex flex-col items-center gap-4">
              <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin" />
              <p className="text-muted-foreground">Loading campaigns...</p>
            </div>
          </div>
        ) : campaigns.length === 0 ? (
          <div className="text-center py-20" data-testid="no-campaigns-message">
            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-secondary flex items-center justify-center">
              <FolderOpen className="w-10 h-10 text-muted-foreground" />
            </div>
            <h3 className="text-xl font-semibold text-foreground mb-2">
              No campaigns yet
            </h3>
            <p className="text-muted-foreground mb-6">
              Start your first campaign to support a cause you care about
            </p>
            <Link to="/campaigns/new">
              <Button className="rounded-full gap-2">
                <Plus className="w-4 h-4" />
                Start a Campaign
              </Button>
            </Link>
          </div>
        ) : (
          <div
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 stagger-children"
            data-testid="my-campaigns-grid"
          >
            {campaigns.map((campaign) => (
              <CampaignCard key={campaign.id} campaign={campaign} showStatus />
            ))}
          </div>
        )}
      </div>
    </PageLayout>
  );
}
